<template>
  <div
    class="text-center py-[16px] flex items-center justify-center gap-[8px] flex-wrap"
  >
    <b-spinner
      v-if="fetcher.isLoading"
      variant="primary"
      small
    />
    <span class="text-[#828282]">{{ label }}</span>
    <b-button
      v-if="fetcher.error"
      variant="primary"
      size="sm"
      @click="fetcher.fetchData()"
    >
      Coba lagi
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    fetcher: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: 'Memuat data...',
    },
  },
}
</script>
